'use client'

import NextLink from '@/components/NextLink'
import Button from '@/components/ui/Button'
import Image from 'next/image'

export default function MissingPage() {
  return (
    <div className=' h-full min-h-dvh md:min-h-full px-4 w-full flex items-center  flex-col'>
      <Image width={400} height={400} alt='404' src={`${process.env.NEXT_PUBLIC_STORAGE_URL}image/9d5f1691-5734-44ed-ab28-7a4a003e2f0b-planingo.png`} />
      <h1 className='text-lg md:text-2xl font-semibold md:font-bold mt-10 md:mt-12'>Oops! Lost in Travel?</h1>
      <p className='mt-2 text-sm md:text-base font-normal text-gray-500 text-center'>The page you’re looking for seems to have taken a detour. Let’s get you back on track!</p>
      <div className='flex items-center justify-center mt-6 gap-6'>
        <NextLink href='/'>
          <Button color='ghostIndigo' >
            Go Home
          </Button>
        </NextLink>
        <Button color='primary' onClick={() => window.location.reload()} >
          Try Again
        </Button>
      </div>
    </div>
  )
}